module.exports = __webpack_public_path__ + "img/img_market.d1741061.png";